module.exports = __webpack_public_path__ + "media/images/banner/banner_ac-promotion-f4adeab884cd26179579e5258ee98a7b.jpg";